@if (showHeader) {
  <ui-message-custom>
    {{ 'orderProcess.payment.zeroPayment.note' | translate }}
  </ui-message-custom>
  <div class="d-flex mt-5 mb-4 flex-column align-items-start flex-lg-row align-items-lg-end mt-2">
    <h4 class="me-2 mb-0">{{ 'orderProcess.payment.contactForm.title' | translate }}</h4>
    <div class="text-primary cursor-pointer font-md d-none d-sm-block"
         [translate]="'orderProcess.payment.whyDoAskInfo.question'"
         ngbTooltip="{{'orderProcess.payment.whyDoAskInfo.answer' | translate}}">
    </div>
  </div>
}

<payment-contact-info
  [userInfo]="contactInfo"
  [countryCode]="countryCode"
  [personType]="personType"
  [bakeryId]="bakeryId"
  [askForReferenceField]="personType === PAYMENT_PERSON_TYPES.COMPANY"
  [useCompanySearcher]="personType === PAYMENT_PERSON_TYPES.COMPANY"
  (onCompanySelected)="onCompanySelected.emit($event)"
  (onInfoUpdated)="onInfoUpdated($event)"
  (onValidUpdated)="isContactInfoValid = $event"
></payment-contact-info>

<div>
  <div class="mt-4 mb-4">
    <ui-newsletter-signup
      class="d-block mb-3"
      *ngIf="!alreadySubscriber"
      [isSubscribe]="contactInfo?.subscribedOnNews"
      (onChange)="newsletterUpdate($event)"
    ></ui-newsletter-signup>
  </div>

  <div class="mb-3 text-center-md-max">
    <button class="btn btn-pink btn-xl"
            [disabled]="!isContactInfoValid"
            (click)="submit()">
      {{ 'common.confirm' | translate }}
    </button>
  </div>


  <terms-and-conditions (onTermsClick)="onTermsClick.emit()">
  </terms-and-conditions>
</div>
